import React from 'react';
import FourOhFourImage from '@punchcard/core/assets/404.png';
import { useTranslation } from 'react-i18next';

const FourOhFour = () => {
	const { t } = useTranslation();

	return (
		<div className="bg-quaternary-400 d-flex flex-column justify-content-center align-items-center h-100">
			<img src={FourOhFourImage} alt="404 Icon"></img>
			<h4 className="text-quaternary-800 mt-5">{t('error.message404')}</h4>
			<span className="text-quaternary-800 mt-1">{t('error.description404')}</span>
		</div>
	);
};

export default FourOhFour;
